import { currentlyEditingSleeperSelector } from "../redux/slices/customNavigation";
import {
  isSingleSleeperSelector,
  primarySleeperFirstNameSelector,
  secondarySleeperFirstNameSelector,
} from "../redux/slices/mattressConfiguration";
import { useSelector } from "react-redux";
import React from "react";

import backSleeperSVG from "../assets/images/sleep_styles/sleepStyleBackGreen.svg";
import painPointHipGreen from "../assets/images/painPoints/painPointHipGreen.svg";
import painPointLowerBackPainGreen from "../assets/images/painPoints/painPointLowerBackPainGreen.svg";
import painPointMidBackGreen from "../assets/images/painPoints/painPointMidBackGreen.svg";
import painPointShoulderGreen from "../assets/images/painPoints/painPointShoulderGreen.svg";
import sideSleeperSVG from "../assets/images/sleep_styles/sleepStyleSideGreen.svg";
import sleepStyleVariedGreen from "../assets/images/sleep_styles/sleepStyleVariedGreen.svg";
import stomachSleeperSVG from "../assets/images/sleep_styles/sleepStyleStomachGreen.svg";

import { getFromLocalStorage, saveToLocalStorage } from "./browser.utils";

export const getFirstName = () => {
  const primarySleeperFirstName = useSelector(primarySleeperFirstNameSelector);
  const secondarySleeperFirstName = useSelector(
    secondarySleeperFirstNameSelector
  );
  const isSingleSleeper = useSelector(isSingleSleeperSelector);
  const currentlyEditingSleeper = useSelector(currentlyEditingSleeperSelector);

  const editingSleeper1 = currentlyEditingSleeper === 1;

  const displayName =
    isSingleSleeper || editingSleeper1
      ? primarySleeperFirstName
      : secondarySleeperFirstName;

  return displayName;
};

export const getSleepStyleName = index => {
  const sleepStyleNames = ["Side", "Back", "Stomach", "Varied"];
  return sleepStyleNames[index];
};

export const hasPainPoints = painPointsObject => {
  const painPointsArray = [];
  Object.keys(painPointsObject).map(painPoint => {
    if (painPointsObject[painPoint]) {
      painPointsArray.push(painPoint);
    }
  });
  return painPointsArray;
};

export const getPainPointsName = index => {
  const sleepStyleNames = ["Hip", "Shoulder", "Lower Back", "Mid-Back"];
  return sleepStyleNames[index];
};
export const getSleepStyleInfoMessage = index => {
  const sleepStyleInfoMessage = ["softer", "medium-firm", "firmer", "medium"];
  return sleepStyleInfoMessage[index];
};
export const getPainPointsInfoMessage = index => {
  const sleepStyleInfoMessage = [
    "soften the support layer",
    "soften the comfort layer",
    "add in extra lumbar support",
    "soften the comfort layer",
  ];
  return sleepStyleInfoMessage[index];
};

export const getPainPointsSVG = index => {
  const svgs = [
    painPointHipGreen,
    painPointShoulderGreen,
    painPointLowerBackPainGreen,
    painPointMidBackGreen,
  ];
  return svgs[index];
};

export const getSleepStyleSVG = index => {
  const svgs = [
    sideSleeperSVG,
    backSleeperSVG,
    stomachSleeperSVG,
    sleepStyleVariedGreen,
  ];
  return svgs[index];
};

export const getLayerString = bmi => {
  if (bmi < 18.5) {
    return "more softness in the support layer";
  } else if (bmi < 25) {
    return "a soft support layer";
  } else if (bmi < 30) {
    return "a medium support layer";
  } else {
    return "a firm support layer ";
  }
};

export const NewlineText = props => {
  const text = props.text;
  return text.split("\n").map(str => <p key={text}>{str}</p>);
};

export const getInfoModalText = index => {
  const textContent = [
    "Everybody is unique and we all come in different shapes and sizes.  Even more obvious is that most couples will comprise each others sleep to both be on the same mattress. With years of experience fitting people into the right mattress we know the Height, Weight, and Shape are major factors to get the right level of Surface Comfort with the right amount of deeper Support. \n" +
      "We use these factors as a starting point in the journey to ultimate sleep. \n" +
      "How we use this information: " +
      "Generally speaking, someone that is petite/smaller will need less support/firmness and more comfort/surface softness. Someone with average body size would need medium support with some surface comfort. Someone that is bigger generally needs more support deeper down, but still needs some pressure point relief. \n",
    "Everyone sleeps differently, but your dominate sleep positions will impact what combination of support and comfort works best for you.\n" +
      "We make slight adjustments to either your support or comfort layer to accommodate your Sleep Positions.\n" +
      "The most prominent sleep position is Side Sleepers. Since we have more curves/shape when on our sides we make sure the surface comforter is a bit softer so the mattress can contour to everyone’s various shapes.\n" +
      "Back Sleepers don’t have the same amount of curves but they still need some contouring to ensure proper spinal alignment. We add a bit more to the support layer to provide the support but still maintain surface softness.\n" +
      "Stomach Sleepers tend to like a firm feel with little sink as they need there hips supported to support the spine. They will normally like a mattress on the firmer side. We increase both the support and comfort layer to get the right fit.\n" +
      "For those that  don’t know and sleep in all positions, do not fret. Our mattress are comfortable and supportive, and we will use all information for the best design for you.\n",
    "Not everyone has pain points, but sometimes sports injures, accidents or age cause pain points or concerns in certain areas of the body. We can’t resolve or fix every concern, but with our expertise and knowledge we sometimes address these issues and in the end provide the optimum sleep for your circumstances.\n" +
      "Our sleep experts will look at this information and will let you know what recommendations we think will address those concerns.\n" +
      "With specific issues it can be hard to isolate the exact areas because addressing the one issue might impact other areas. Example if soften up the mattress for your hips does that reduce support and then cause a back issue. We try to take the big picture into account.\n" +
      "Shoulder and Hip pain normally mean there is too much firmness or not enough contouring in those areas. We may recommend softening the mattress to help reduce presssue. \n" +
      "For Lower and Mid Back pain we may recommend more firmness or add support to target those areas. \n" +
      "If you have Neck issues we would recommend finding the right pillow for your mattress.\n" +
      "For other issues, please let us know, and we will see what we can do.\n" +
      "\n",
    "Just because we think we know what is best for you from your body size and sleep positions, we don’t assume to know what you like or need. You might have underlying issues that we don’t know about, or maybe you were in a ski accident and know you need something very firm to support that issue. It is important for us to know, so we can better personalize you right support and comfort. \n" +
      "If you know that you sleep better with more firmness we want to know.\n" +
      "If you know that you sleep better with more softness we want to know.\n" +
      "We will take this information along with everything else and will adjust support and comfort to a level that we think would be good to get you in line with your preference.\n" +
      "If we don’t nail it, no worries. You have 120 days to make an adjustment.\n",
    "Everybody is unique and we all come in different shapes and sizes.  Even more obvious is that most couples will comprise each others sleep to both be on the same mattress. With years of experience fitting people into the right mattress we know the Height, Weight, and Shape are major factors to get the right level of Surface Comfort with the right amount of deeper Support. \n" +
      "We use these factors as a starting point in the journey to ultimate sleep. \n" +
      "How we use this information: " +
      "Generally speaking, someone that is petite/smaller will need less support/firmness and more comfort/surface softness. Someone with average body size would need medium support with some surface comfort. Someone that is bigger generally needs more support deeper down, but still needs some pressure point relief. \n",
  ];
  return textContent[index];
};

export const getBedSizeName = bedSize => {
  const bedSizeNames = {
    twin: "Twin XL",
    queen: "Queen",
    king: "King",
    caliKing: "Cali-King",
  };
  return bedSizeNames[bedSize];
};

export const painPointsIndexReference = {
  hip: 0,
  shoulder: 1,
  lowerBack: 2,
  midBack: 3,
};

const months = {
  0: "January",
  1: "February",
  2: "March",
  3: "April",
  4: "May",
  5: "June",
  6: "July",
  7: "August",
  8: "September",
  9: "October",
  10: "November",
  11: "December",
};

export const getEstimatedDelivery = () => {
  const d = new Date(Date.now() + 12096e5);
  return `${months[d.getMonth()]} ${d.getDate()}`;
};

export const saveMattressConfigurationToLocalStorage =
  mattressConfiguration => {
    saveToLocalStorage(
      "evrbedMattressConfiguration",
      JSON.stringify(mattressConfiguration)
    );
  };
export const getMattressConfigurationFromLocalStorage = () => {
  const mattressConfiguration = getFromLocalStorage(
    "evrbedMattressConfiguration"
  );
  return mattressConfiguration;
};
